export default __webpack_public_path__ + "static/media/UniversLTStd-Ex.4c45afb5.otf";